require('@fancyapps/fancybox');
window.fancyBoxJquery = $;
